import { Modal, Popover, Tag, message } from "antd";
import { MoreMenu } from "datastake-daf/dist/components";
import TooltipIcon from "../../../../../components/dashboards/components/TooltipIcon";
import { camelCaseToTitle, findOptions } from "../../../../../helpers/StringHelper";
import { copyToClipboard } from "../../../../../helpers/copyToClipboard";

export const filtersConfig = {
  name: '',
  datastakeId: '',
};

export const selectFiltersConfig = {
  category: {
    type: 'select',
    label: 'Category',
    placeholder: (t) => `${t('Filter by')} ${t('Category').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
};

export const checkboxConfig = {
  name: 'Name',
  datastakeId: 'ID',
};

export const hardcodedDataRequests = [
  {
    id: '11',
    datastakeId: 'DS000000001',
    name: 'HIVE',
    type: 'source',
    email: 'hive@g.com',
    category: 'Government',
    settings: 'Standard',
    status: 'pending',
  },
  {
    id: '33',
    datastakeId: 'DS000000003',
    name: 'HIVE 3',
    type: 'source',
    category: 'Government',
    settings: 'Standard',
    email: 'hive@g.com',
    status: 'declined',
  },
  {
    id: '22',
    datastakeId: 'DS000000002',
    email: 'hive@g.com',
    name: 'HIVE 2',
    type: 'source',
    category: 'Government',
    settings: 'Custom',
    status: 'blocked',
  },
];

export const hardcodedData = [
  {
    id: '11',
    datastakeId: 'DS000000001',
    name: 'HIVE',
    type: 'source',
    category: 'Government',
    email: 'hive@g.com',
    settings: 'Standard',
    status: 'active',
  },
  {
    id: '22',
    datastakeId: 'DS000000002',
    name: 'HIVE 2',
    email: 'hive@g.com',
    type: 'source',
    category: 'Government',
    settings: 'Custom',
    status: 'inactive',
  },
  {
    id: '33',
    datastakeId: 'DS000000003',
    name: 'HIVE 3',
    email: 'hive@g.com',
    type: 'source',
    category: 'Government',
    settings: 'Custom',
    status: 'pending',
  },
];

export const partnerTypes = [
  { label: 'Individual', value: 'individual' },
  { label: 'Organisation', value: 'organisation' }
]

export const partnershipTypes = [
  { label: 'Source', value: 'source' },
  { label: 'Client', value: 'client' },
  { label: 'Exchange', value: 'exchange' },
]

export const getColumns = ({
  t,
  accept,
  decline,
  suspend,
  selectOptions = {},
  resendInvite,
  activate,
  activeTab,
  setEditVisible,
  block
}) => [
    {
      title: t('ID'),
      dataIndex: 'datastakeId',
      key: 'datastakeId',
      ellipsis: true,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return v || t('Depends');
      }
    },
    {
      title: (
        <div className="flex-row">
          {t('Partner Type')}
          <Popover
            title={t('Partner Type')}
            content={(
              <div className="max-w-250">
                {t('Source: This partner shares information with your organisation.')}
                {' '}
                <br />
                <br />
                {t('Client: This partner receives information from your organisation.')}
                <br />
                <br />
                {t('Exchange: You share information with each other.')}
              </div>
            )}
          >
            <div className="ml-2 flex flex-column justify-content-center">
              <TooltipIcon fontSize={12} />
            </div>
          </Popover>
        </div>
      ),
      dataIndex: 'partnershipType',
      key: 'partnershipType',
      ellipsis: true,
      render: (val, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return partnershipTypes.find((v) => v.value === val)?.label || val || '--';
      },
    },

    {
      title: (
        <div className="flex-row">
          {t('Entity Type')}
        </div>
      ),
      dataIndex: 'partnerType',
      key: 'partnerType',
      ellipsis: true,
      render: (val, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return partnerTypes.find((v) => v.value === val)?.label || val || '--';
      },
    },
    {
      title: t('Name'),
      dataIndex: 'nickName',
      key: 'nickName',
      ellipsis: true,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return v || '--';
      }
    },
    {
      title: t('Category'),
      dataIndex: 'category',
      key: 'category',
      ellipsis: true,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return v ? findOptions(v, selectOptions?.category || []) : '--';
      }
    },
    {
      title: (
        <div className="flex-row">
          {t('Settings')}
          <Popover
            title={t('Settings')}
            content={(
              <div className="max-w-250">
                {t('Standard: information is licensed with citation and available without restriction.')}
                <br />
                <br />
                {t('Custom: Information sharing settings have been adjusted by the Source as reflected in the corresponding Channel.')}
              </div>
            )}
          >
            <div className="ml-2 flex flex-column justify-content-center">
              <TooltipIcon fontSize={12} />
            </div>
          </Popover>
        </div>
      ),
      dataIndex: 'settings',
      key: 'settings',
      ellipsis: true,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return v ? t(camelCaseToTitle(v)) : '--';
      },
    },
    {
      title: (
        <div className="flex-row">
          {t('Status')}
          <Popover
            title={t('Status')}
            content={(
              <div className="max-w-250">
                {t('Information is shared in accordance with settings for partners designated as Active.')}
                <br />
                <br />
                {t('Information sharing is suspended for partners designated as Inactive.')}
              </div>
            )}
          >
            <div className="ml-2 flex flex-column justify-content-center">
              <TooltipIcon fontSize={12} />
            </div>
          </Popover>
        </div>
      ),
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      render: (val, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        switch (val) {
          case 'active':
            return <Tag color="green">{t('Active')}</Tag>;
          case 'declined':
            return <Tag color="red">{t('Declined')}</Tag>;
          case 'pending':
            return <Tag color="orange">{t('Pending')}</Tag>;
          case 'blocked':
            return <Tag color="red-inverse">{t('Blocked')}</Tag>;
          case 'suspended':
            return <Tag >{t('Suspended')}</Tag>;
          default:
            return '--';
        }
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      width: 60,
      show: true,
      key: 'actions',
      render: (_, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }

        let items = [];

        if (activeTab === 'requests') {
          switch (val.status) {
            case 'declined':
              items.push({
                label: t('Block User'),
                key: 'block',
                onClick: () => Modal.confirm({
                  title: t('Are you sure you want to block this user?'),
                  onOk: () => block(val.id),
                  cancelText: t('No'),
                  okText: t('Yes'),
                  closable: true,
                })
              });
              break;
            case 'pending':
              items.push(...[
                {
                  label: t('Approve'),
                  key: 'approve',
                  onClick: () => Modal.confirm({
                    content: t('Are you sure you want to approve this request?'),
                    title: t('Approve'),
                    onOk: () => accept(val.id),
                    cancelText: t('No'),
                    okText: t('Yes'),
                    closable: true,
                  })
                },
                {
                  label: t('Decline'),
                  key: 'decline',
                  onClick: () => Modal.confirm({
                    title: t('Decline'),
                    content: t('Are you sure you want to decline this request?'),
                    onOk: () => decline(val.id),
                    cancelText: t('No'),
                    okText: t('Yes'),
                    closable: true,
                  })
                },
              ]);
              break;
            default:
          }
        } else {
          switch (val.status) {
            case 'pending':
              items.push({ label: t('Edit Settings'), key: 'edit', onClick: () => setEditVisible(val) });
              items.push({
                label: t('Suspend Partner'),
                key: 'suspend',
                onClick: () => Modal.confirm({
                  title: t('Suspend Partner'),
                  content: t('Are you sure you want to suspend this partner?'),
                  onOk: () => suspend(val.id),
                  cancelText: t('No'),
                  okText: t('Yes'),
                  closable: true,
                })
              });
              items.push({
                label: t('Copy Invitation Link'),
                key: 'copyInvitationLink',
                disabled: !val.code,
                onClick: () => {
                  const copyText = document.getElementById("myInput");
                  copyText.value = val.datastakeId ? `${window.location.origin}/tazama/app-invitation?code=${val.code}` : `${window.location.origin}/tazama/register?code=${val.code}`;
                  copyToClipboard('myInput')
                  message.info(t('Invitation link copied!'));
                },
              });
              items.push({
                label: t('Resend Invite'),
                key: 'resendInvite',
                onClick: () => Modal.confirm({
                  title: t('Resend Invitation'),
                  content: t('Are you sure you want to invite this user again? This user will receive a new notification'),
                  onOk: () => resendInvite(val.id),
                  cancelText: t('No'),
                  okText: t('Yes'),
                  closable: true,
                })
              });
              break;
            case 'suspended':
              items.push({
                label: t('Activate Partner'),
                key: 'activate',
                onClick: () => Modal.confirm({
                  title: t('Re-activate Partnership'),
                  content: t('Are you sure you want to re-activate this collaboration?'),
                  onOk: () => activate(val.id),
                  cancelText: t('No'),
                  okText: t('Yes'),
                  closable: true,
                })
              });
              break;
            case 'active':
              items.push({ label: t('Edit Settings'), key: 'edit', onClick: () => setEditVisible(val) });
              items.push({
                label: t('Suspend Partner'),
                key: 'suspend',
                onClick: () => Modal.confirm({
                  title: t('Suspend Partner'),
                  content: t('Are you sure you want to suspend this partner?'),
                  onOk: () => suspend(val.id),
                  cancelText: t('No'),
                  okText: t('Yes'),
                  closable: true,
                })
              });
              break;
            default:
          }

        }

        return (
          <MoreMenu items={items} />
        );
      }
    }
  ];
